var getPrices = function (financials, model) {
    var _a, _b, _c, _d;
    var modelFinancials = (_a = financials.models) === null || _a === void 0 ? void 0 : _a.find(function (modelPricing) { var _a; return (modelPricing === null || modelPricing === void 0 ? void 0 : modelPricing.modelKey) === ((_a = model.detModelKey) === null || _a === void 0 ? void 0 : _a.value); });
    var trim = (_b = modelFinancials === null || modelFinancials === void 0 ? void 0 : modelFinancials.trims) === null || _b === void 0 ? void 0 : _b[0];
    var transmission = (_c = trim === null || trim === void 0 ? void 0 : trim.transmissions) === null || _c === void 0 ? void 0 : _c[0];
    var exteriorColor = (_d = transmission === null || transmission === void 0 ? void 0 : transmission.exteriorColors) === null || _d === void 0 ? void 0 : _d[0];
    return {
        msrp: exteriorColor === null || exteriorColor === void 0 ? void 0 : exteriorColor.msrp,
        sellingPrice: exteriorColor === null || exteriorColor === void 0 ? void 0 : exteriorColor.sellingPrice,
    };
};
var getPEHydratedTrims = function (models, financials, msrpStartingFromLabel, sellingPriceLabel, priceTooltipLabel, showMsrpPrice, showSellingPrice) {
    return models.map(function (model) {
        var _a, _b, _c, _d, _e, _f;
        return ({
            detIdentifier: (_a = model.detIdentifier) === null || _a === void 0 ? void 0 : _a.value,
            detKey: (_b = model.detKey) === null || _b === void 0 ? void 0 : _b.value,
            image: (_d = (_c = model.primaryImage) === null || _c === void 0 ? void 0 : _c.item) === null || _d === void 0 ? void 0 : _d.value,
            name: model.modelName.value,
            modelCode: (_e = model.modelCode) === null || _e === void 0 ? void 0 : _e.value,
            modelKey: (_f = model.detKey) === null || _f === void 0 ? void 0 : _f.value,
            priceLabelMsrp: msrpStartingFromLabel,
            priceLabelSelling: sellingPriceLabel,
            priceTooltipLabel: priceTooltipLabel,
            showMsrpPrice: showMsrpPrice,
            showSellingPrice: showSellingPrice,
            priceMsrp: getPrices(financials, model).msrp,
            priceSelling: getPrices(financials, model).sellingPrice,
        });
    });
};
export default getPEHydratedTrims;
